"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactTableV = _interopRequireDefault(require("react-table-v6"));
var _PaginationV = _interopRequireDefault(require("../pagination/PaginationV1"));
var _TableSkeleton = require("../skeleton/TableSkeleton");
var _TableEmpty = require("../skeleton/TableEmpty");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var cellActiveColor = '#F0F6FD';
var cellDisableColor = '#F4F4F4';
var customStyle = {
  background: cellDisableColor,
  pointerEvents: 'none',
  cursor: 'default'
};
var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);
  var _super = _createSuper(Table);
  function Table(props) {
    var _this;
    _classCallCheck(this, Table);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "reactTableContainerRef", /*#__PURE__*/_react.default.createRef());
    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (event) {
      var _this$reactTableConta;
      var target = event.target || event.srcElement;
      var _this$props$topSticky = _this.props.topStickyHeight,
        topStickyHeight = _this$props$topSticky === void 0 ? 62 : _this$props$topSticky;
      var _this$state = _this.state,
        isHorizontalScroll = _this$state.isHorizontalScroll,
        horizontalScrollEnd = _this$state.horizontalScrollEnd;
      if (_this.props.isStickyHeader) {
        var tableHead = document.getElementsByClassName('rt-thead')[0];
        var tableHeadCell = document.getElementsByClassName('rt-th');
        var tableNewClass = 'rt-th rt-resizable-header tl-table-sticky-header-cell';
        var tableCurrentClass = 'rt-th rt-resizable-header';
        var headerCellLength = tableHeadCell.length;
        var columns = _this.props.columns;
        if (tableHead) {
          var screenPosition = tableHead.getBoundingClientRect();
          if (screenPosition.top <= topStickyHeight) {
            _this.updateHeaderClass(tableHeadCell, tableNewClass, columns, headerCellLength);
          } else {
            _this.updateHeaderClass(tableHeadCell, tableCurrentClass, columns, headerCellLength);
          }
        }
      }
      if ((_this$reactTableConta = _this.reactTableContainerRef.current) !== null && _this$reactTableConta !== void 0 && _this$reactTableConta.contains(target)) {
        var previousIsHorizontalScroll = isHorizontalScroll;
        var previousHorizontalScrollEnd = horizontalScrollEnd;
        var trGroupPos = target.querySelector('.rt-tr-group').getBoundingClientRect();
        var targetRight = target.getBoundingClientRect().right;
        if (trGroupPos.right === targetRight) {
          horizontalScrollEnd = true;
        } else {
          horizontalScrollEnd = false;
        }
        var state = {
          horizontalScrollEnd: horizontalScrollEnd
        };
        if (!isHorizontalScroll && target.scrollLeft > 0) {
          isHorizontalScroll = true;
        } else if (target.scrollLeft === 0) {
          isHorizontalScroll = false;
        }
        if (isHorizontalScroll !== previousIsHorizontalScroll || horizontalScrollEnd !== previousHorizontalScrollEnd) {
          _this.setState({
            isHorizontalScroll: isHorizontalScroll,
            horizontalScrollEnd: horizontalScrollEnd
          });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "updateHeaderClass", function (tableHeadCell, tableClass, columns, headerCellLength) {
      for (var item = 0; item < headerCellLength; item++) {
        if (columns[item]) {
          tableHeadCell[item].className = tableClass + ' ' + columns[item].headerClassName;
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "activeElement", function (state, rowInfo) {
      var updatedStyle = {
        style: {}
      };
      var activeItem = function activeItem(isFound) {
        return isFound ? updatedStyle.style = {
          background: cellActiveColor
        } : '';
      };
      var disableItem = function disableItem(isFound) {
        return isFound ? updatedStyle.style = customStyle : '';
      };
      if (_this.props.activeRows) activeItem(_this.props.activeRows.includes(rowInfo.viewIndex));
      if (_this.props.disabledRows) disableItem(_this.props.disabledRows.includes(rowInfo.viewIndex));
      return updatedStyle;
    });
    _defineProperty(_assertThisInitialized(_this), "validateData", function () {
      var _this$state$data = _this.state.data,
        data = _this$state$data === void 0 ? [] : _this$state$data;
      var _this$props = _this.props,
        _this$props$loading = _this$props.loading,
        loading = _this$props$loading === void 0 ? false : _this$props$loading,
        _this$props$columns = _this$props.columns,
        columns = _this$props$columns === void 0 ? [] : _this$props$columns;
      var validate = true;
      if (loading) {
        return false;
      }
      if ((data || []).length === 0) {
        validate = false;
      }
      if ((columns || []).length === 0) {
        validate = false;
      } else {
        validate = true;
      }
      return validate;
    });
    _this.state = {
      pageSize: _this.props.defaultPageSize,
      activeClass: -1,
      data: _this.props.data || [],
      customPage: _this.props.page || 0,
      isHorizontalScroll: false,
      horizontalScrollEnd: false
    };
    return _this;
  }
  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var tableClassName = 'tl-table-main-container tl-ui tl-table-type-basic tl-Advance-tableV3 ';
      tableClassName += this.props.isStickyHeader ? 'tl-table-sticky-container' : '';
      var classArray = tableClassName.split(' ');
      if (this.state.isHorizontalScroll) {
        classArray = classArray.concat('tl-rt-table-scrolling-hz');
      }
      if (this.state.horizontalScrollEnd) {
        classArray = classArray.concat('tl-rt-table-scrolling-hz-end');
      }
      tableClassName = classArray.join(' ');
      var _this$props2 = this.props,
        _this$props2$loading = _this$props2.loading,
        loading = _this$props2$loading === void 0 ? false : _this$props2$loading,
        _this$props2$columns = _this$props2.columns,
        columns = _this$props2$columns === void 0 ? [] : _this$props2$columns,
        _this$props2$showEmpt = _this$props2.showEmptyMessage,
        showEmptyMessage = _this$props2$showEmpt === void 0 ? false : _this$props2$showEmpt;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: tableClassName,
        style: this.props.containerClassName,
        id: this.props.id,
        ref: this.reactTableContainerRef
      }, loading && /*#__PURE__*/_react.default.createElement(_TableSkeleton.TableSkeleton, this.props), this.validateData() && /*#__PURE__*/_react.default.createElement(_reactTableV.default, {
        data: this.state.data,
        columns: columns,
        showPagination: this.props.showPagination ? true : false,
        PaginationComponent: _PaginationV.default,
        totalRecordLength: this.props.totalRecordLength,
        defaultPageSize: this.props.defaultPageSize,
        pageSize: this.props.pageSize,
        getTdProps: this.props.getTdProps,
        style: this.props.style,
        showPageJump: this.props.showPageJump,
        collapseOnSortingChange: this.props.collapseOnSortingChange,
        collapseOnPageChange: this.props.collapseOnPageChange,
        collapseOnDataChange: this.props.collapseOnDataChange,
        freezeWhenExpanded: this.props.freezeWhenExpanded,
        sortable: this.props.sortable,
        multiSort: this.props.multiSort,
        minRows: 0,
        resizable: this.props.resizable,
        filterable: false,
        defaultSortDesc: this.props.defaultSortDesc,
        getProps: this.props.getProps,
        getTableProps: this.props.getTableProps,
        getTheadGroupProps: this.props.getTheadGroupProps,
        getTheadGroupTrProps: this.props.getTheadGroupTrProps,
        getTheadGroupThProps: this.props.getTheadGroupThProps,
        getTheadProps: this.props.getTheadProps,
        getTheadTrProps: this.props.getTheadTrProps,
        getTheadThProps: this.props.getTheadThProps,
        getTheadFilterProps: this.props.getTheadFilterProps,
        getTheadFilterTrProps: this.props.getTheadFilterTrProps,
        getTheadFilterThProps: this.props.getTheadFilterThProps,
        getTbodyProps: this.props.getTbodyProps,
        getTrProps: this.props.getTrProps,
        getTfootProps: this.props.getTfootProps,
        getTfootTrProps: this.props.getTfootTrProps,
        getTfootTdProps: this.props.getTfootTdProps,
        getLoadingProps: this.props.getLoadingProps,
        getNoDataProps: this.props.getNoDataProps,
        getResizerProps: this.props.getResizerProps,
        onSortedChange: this.props.onSortedChange,
        onPageSizeChange: function onPageSizeChange(pageSize) {
          _this2.props.onPageSizeChange && _this2.props.onPageSizeChange(pageSize);
          _this2.setState({
            pageSize: pageSize,
            customPage: 0
          });
        },
        getPaginationProps: this.props.getPaginationProps,
        getTrGroupProps: this.props.getTrGroupProps || this.activeElement,
        SubComponent: this.props.SubComponent,
        className: this.props.className,
        expanded: this.props.expanded,
        onPageChange: function onPageChange(pageIndex) {
          _this2.props.onPageChange && _this2.props.onPageChange(pageIndex);
          _this2.setState({
            customPage: pageIndex < 0 ? 0 : pageIndex
          });
        },
        page: this.state.customPage < 0 ? 0 : this.state.customPage,
        defaultSorted: this.props.defaultSorted,
        pageSizeOptions: this.props.pageSizeOptions
      }), showEmptyMessage && /*#__PURE__*/_react.default.createElement(_TableEmpty.TableEmpty, _extends({}, this.props, {
        data: this.state.data
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      return {
        data: props.data || [],
        customPage: props.data && props.data.length !== state.data.length ? 0 : state.customPage
      };
    }
  }]);
  return Table;
}(_react.default.Component);
exports.Table = Table;